import { Dialog } from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { GREEN_40, RED_50 } from "../../constants/css.constants";
import React from "react";

const Modal = ({
  handleYes,
  text,
  isOpen,
  disabled,
  handleClose,
}: {
  handleYes: () => void;
  handleClose: () => void;
  text: string;
  isOpen: boolean;
  disabled: boolean;
}) => (
  <Dialog open={isOpen}>
    <Typography style={{ padding: "20px" }}>{text}</Typography>
    <Box
      display="flex"
      justifyContent="center"
      style={{ marginBottom: "20px" }}
    >
      <Button
        disabled={disabled}
        onClick={handleYes}
        style={{
          width: "100px",
          height: "50px",
          backgroundColor: GREEN_40,
          marginRight: "25px",
        }}
      >
        YES
      </Button>
      <Button
        onClick={handleClose}
        style={{
          width: "100px",
          height: "50px",
          backgroundColor: RED_50,
        }}
      >
        NO
      </Button>
    </Box>
  </Dialog>
);

export default Modal;
